<template>
  <v-btn
    :color="selected ? 'white' : 'transparent'"
    height="32"
    rounded
    elevation="0"
    class="c360-proposal-step px-4"
    :class="[selected && 'selected']"
    :disabled="disabled"
    v-on="$listeners"
  >
    <c360-icon
      v-if="!selected"
      icon="Circle_Check"
      :size="16"
      class="c360-proposal-step-icon mr-1 mb-n1"
      :class="[active && 'active']"
      v-on="$listeners"
    />
    <span>{{ index }} · {{ name }}</span>
  </v-btn>
</template>

<script>
  import Vue from 'vue';
  import { C360Icon } from '../../../components/Icon';

  export default Vue.extend({
    name: 'C360ProposalStep',

    components: {
      C360Icon,
    },

    props: {
      /**
       * Name of the step.
       */
      name: {
        type: String,
        required: true,
      },

      /**
       * Number of the step.
       */
      index: {
        type: Number,
        required: true,
      },

      /**
       * Is step selected.
       */
      selected: {
        type: Boolean,
        default: false,
      },

      /**
       * Is step active.
       */
      active: {
        type: Boolean,
        default: false,
      },

      /**
       * Is step disabled.
       */
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  });
</script>

<style scoped>
  .c360-proposal-step {
    font-family: var(--c360-font);
    text-transform: none;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: -0.02rem;
    border-radius: 25px;
    position: relative;
    color: var(--c360-color-charcoal);
  }

  .c360-proposal-step.selected::after {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    background: var(--c360-gradient-accent) !important;
    border-radius: 25px;
    padding: 2px;
    box-sizing: content-box;
    z-index: -1;
  }

  .c360-proposal-step.v-btn.v-btn--disabled {
    background-color: transparent !important;
  }

  .c360-proposal-step-icon {
    color: var(--c360-color-smooth-gray);
    align-self: baseline;
  }

  .c360-proposal-step-icon.active {
    color: var(--c360-color-green);
  }
</style>
